// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
// ─────────────────────────────────────────────────────────────────────────────
// CRITICAL PAGE STYLES
// Above-the-fold and high-priority styles for the home page's landing section.
// Put the first section of the home page in here, so it loads immediately.
// The rest of the home page styles in local.css will be deferred and
// ─────────────────────────────────────────────────────────────────────────────
 */

/* ******************* */
/*        HERO         */
/* ******************* */
@media only screen and (min-width: 0rem) {
  #hero {
    /* Centers button */
    text-align: center;
    /* 46px - 300px */
    padding: clamp(2.875rem, 25.95vw, 18.75rem) calc(16 / 16 * 1rem) 0;
    /* 130px - 450px */
    padding-bottom: clamp(12.125rem, 30.95vw, 28.125rem);
    padding-top: 0;
    padding-bottom: 6.375rem;
    /* 46px */
    margin-top: 2.875rem;
    position: relative;
    z-index: 1;
    /* Prevents white rectangle pseudos from overlapping the sections below */
    overflow: hidden;

    .container {
      width: 100%;
      max-width: calc(1110 / 16 * 1rem);
      margin: auto;
      padding: 0.625rem;
    }

    .title {
      /* 40px - 56px */
      font-size: clamp(2.5rem, 6.4vw, 3.5rem);
      font-weight: 700;
      line-height: 1.2em;
      text-align: center;
      max-width: calc(700 / 16 * 1rem);
      /* 16px - 24px */
      margin: 0 auto clamp(1rem, 4vw, 1.5rem);
      position: relative;
    }

    .text {
      /* 16px - 25px */
      font-size: clamp(1rem, 1.95vw, 1.5625rem);
      line-height: 1.5em;
      text-align: center;
      width: 100%;
      max-width: 29rem;
      margin: 0 auto;
      /* 40px - 48px */
      margin-bottom: clamp(2rem, 4vw, 3rem);
      margin-top: 1.5rem;
    }

    .background {
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -2;

      &:before {
        /* Overlay */
        content: "";
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.7;
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        z-index: 1;
        /* prevents the cursor from interacting with it */
        pointer-events: none;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
}

@media only screen and (min-width: 64rem) {
  #hero {
    margin-top: calc(120 / 16 * 1rem);
    /* Justify button left */
    text-align: start;
    .container {
      padding: 0;
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
    }

    .title {
      text-align: start;
      line-height: 1.15em;
      letter-spacing: -1px;
    }

    .text {
      text-align: start;
      font-size: 1rem;
      max-width: 32ch;
      margin-left: 0;
      margin-right: auto;
    }

    .image-container {
      width: calc(540 / 16 * 1rem);

      img {
        width: 100%;
        height: auto;
      }
    }

    .text-container {
      /* width: calc(445 / 16 * 1rem); */
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/critical.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kEAAkE;IAClE,kBAAkB;IAClB,oDAAoD;IACpD,cAAc;IACd,wBAAwB;IACxB,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,yEAAyE;IACzE,gBAAgB;;IAEhB;MACE,WAAW;MACX,iCAAiC;MACjC,YAAY;MACZ,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,uCAAuC;MACvC,gBAAgB;MAChB,kBAAkB;MAClB,kBAAkB;MAClB,gCAAgC;MAChC,gBAAgB;MAChB,uCAAuC;MACvC,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,yCAAyC;MACzC,kBAAkB;MAClB,kBAAkB;MAClB,WAAW;MACX,gBAAgB;MAChB,cAAc;MACd,gBAAgB;MAChB,qCAAqC;MACrC,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,cAAc;MACd,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,WAAW;;MAEX;QACE,YAAY;QACZ,WAAW;QACX,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,cAAc;QACd,MAAM;QACN,OAAO;QACP,UAAU;QACV,iDAAiD;QACjD,oBAAoB;MACtB;;MAEA;QACE,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,YAAY;QACZ,WAAW;QACX,iBAAiB;MACnB;IACF;EACF;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,wBAAwB;IACxB,iBAAiB;IACjB;MACE,UAAU;MACV,aAAa;MACb,2BAA2B;MAC3B,8BAA8B;IAChC;;IAEA;MACE,iBAAiB;MACjB,mBAAmB;MACnB,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;MACjB,eAAe;MACf,eAAe;MACf,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,4BAA4B;;MAE5B;QACE,WAAW;QACX,YAAY;MACd;IACF;;IAEA;MACE,kCAAkC;IACpC;EACF;AACF","sourcesContent":["/* \n// ─────────────────────────────────────────────────────────────────────────────\n// CRITICAL PAGE STYLES\n// Above-the-fold and high-priority styles for the home page's landing section.\n// Put the first section of the home page in here, so it loads immediately.\n// The rest of the home page styles in local.css will be deferred and\n// ─────────────────────────────────────────────────────────────────────────────\n */\n\n/* ******************* */\n/*        HERO         */\n/* ******************* */\n@media only screen and (min-width: 0rem) {\n  #hero {\n    /* Centers button */\n    text-align: center;\n    /* 46px - 300px */\n    padding: clamp(2.875rem, 25.95vw, 18.75rem) calc(16 / 16 * 1rem) 0;\n    /* 130px - 450px */\n    padding-bottom: clamp(12.125rem, 30.95vw, 28.125rem);\n    padding-top: 0;\n    padding-bottom: 6.375rem;\n    /* 46px */\n    margin-top: 2.875rem;\n    position: relative;\n    z-index: 1;\n    /* Prevents white rectangle pseudos from overlapping the sections below */\n    overflow: hidden;\n\n    .container {\n      width: 100%;\n      max-width: calc(1110 / 16 * 1rem);\n      margin: auto;\n      padding: 0.625rem;\n    }\n\n    .title {\n      /* 40px - 56px */\n      font-size: clamp(2.5rem, 6.4vw, 3.5rem);\n      font-weight: 700;\n      line-height: 1.2em;\n      text-align: center;\n      max-width: calc(700 / 16 * 1rem);\n      /* 16px - 24px */\n      margin: 0 auto clamp(1rem, 4vw, 1.5rem);\n      position: relative;\n    }\n\n    .text {\n      /* 16px - 25px */\n      font-size: clamp(1rem, 1.95vw, 1.5625rem);\n      line-height: 1.5em;\n      text-align: center;\n      width: 100%;\n      max-width: 29rem;\n      margin: 0 auto;\n      /* 40px - 48px */\n      margin-bottom: clamp(2rem, 4vw, 3rem);\n      margin-top: 1.5rem;\n    }\n\n    .background {\n      width: 100%;\n      height: 100%;\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      z-index: -2;\n\n      &:before {\n        /* Overlay */\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        background: #000;\n        opacity: 0.7;\n        position: absolute;\n        display: block;\n        top: 0;\n        left: 0;\n        z-index: 1;\n        /* prevents the cursor from interacting with it */\n        pointer-events: none;\n      }\n\n      img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 64rem) {\n  #hero {\n    margin-top: calc(120 / 16 * 1rem);\n    /* Justify button left */\n    text-align: start;\n    .container {\n      padding: 0;\n      display: flex;\n      flex-direction: row-reverse;\n      justify-content: space-between;\n    }\n\n    .title {\n      text-align: start;\n      line-height: 1.15em;\n      letter-spacing: -1px;\n    }\n\n    .text {\n      text-align: start;\n      font-size: 1rem;\n      max-width: 32ch;\n      margin-left: 0;\n      margin-right: auto;\n    }\n\n    .image-container {\n      width: calc(540 / 16 * 1rem);\n\n      img {\n        width: 100%;\n        height: auto;\n      }\n    }\n\n    .text-container {\n      /* width: calc(445 / 16 * 1rem); */\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
